import PlansSummary from './containers/PlansSummary';

export default PlansSummary;
